var handleFetchResult = function (result) {
  if (!result.ok) {
    return result.json().then(function (json) {
      if (json.error && json.error.message) {
        throw new Error(result.url + ' ' + result.status + ' ' + json.error.message);
      }
    }).catch(function (err) {
      //showErrorMessage(err);
      console.log(err);
      throw err;
    });
  }
  return result.json();
};

var createCheckoutSession = function (product) {
  return fetch("/member/pay/session", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      product: product
    })
  }).then(function (result) {
    return result.json();
  });
};


fetch("/member/pay/setter", { method: "POST" })
  .then(handleFetchResult)
  .then(function (json) {
    var publishableKey = json.publishableKey;

    var stripe = Stripe(publishableKey);

    document
      .getElementById("product1")
      .addEventListener("click", function (evt) {
        createCheckoutSession("1").then(function (data) {
          // Call Stripe.js method to redirect to the new Checkout page
          /* global Stripe */
          stripe
            .redirectToCheckout({
              sessionId: data.sessionId
            })
            .then(handleResult);
        });
      });

    document
      .getElementById("product3")
      .addEventListener("click", function (evt) {
        createCheckoutSession("3").then(function (data) {
          // Call Stripe.js method to redirect to the new Checkout page
          /* global Stripe */
          stripe
            .redirectToCheckout({
              sessionId: data.sessionId
            })
            .then(handleResult);
        });
      });
  });

// Handle any errors returned from Checkout
var handleResult = function (result) {
  if (result.error) {
    showErrorMessage(result.error.message);
  }
};